export const getLicenseUrl = (licenseType: string) => {
  if (licenseType.toLowerCase().includes('mit')) {
    return 'https://opensource.org/license/mit/'
  }

  if (licenseType.toLowerCase().includes('isc')) {
    return 'https://opensource.org/license/isc/'
  }

  if (licenseType.toLowerCase().includes('apache')) {
    return 'https://www.apache.org/licenses/LICENSE-2.0'
  }

  if (licenseType.toLowerCase().includes('bsd-2')) {
    return 'https://opensource.org/license/bsd-2-clause/'
  }

  if (licenseType.toLowerCase().includes('bsd-3')) {
    return 'https://opensource.org/license/bsd-3-clause/'
  }
}
